module.exports = __webpack_public_path__ + "news-4a753f38/encoding-c671d723d48853ff8aba29a41d9c1ba6.svg";